import Cookies from 'js-cookie'

const getItem = function (key, storage) {
    const item = storage.getItem(key);
    try {
        return JSON.parse(item);
    } catch (e) {
        return item;
    }
};

const setItem = function (key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new Event(`setItem:${key}`));
};

const removeItem = function (key, storage) {
    storage.removeItem(key);
    window.dispatchEvent(new Event(`removeItem:${key}`));
};

const getCookie = function (key) {
    return Cookies.get(key);
};

const getLocal = function (key) {
    return getItem(key, localStorage);
};

const getSession = function (key) {
    return getItem(key, sessionStorage);
};

const setCookie = function (key, value) {
    return Cookies.set(key, value);
};

const setLocal = function (key, value) {
    setItem(key, value, localStorage);
};

const setSession = function (key, value) {
    setItem(key, value, sessionStorage);
};

const removeCookie = function (key) {
    Cookies.remove(key);
};

const removeLocal = function (key) {
    removeItem(key, localStorage);
};

const removeSession = function (key) {
    removeItem(key, sessionStorage);
};

export {
    getCookie,
    getLocal,
    getSession,
    setCookie,
    setLocal,
    setSession,
    removeCookie,
    removeLocal,
    removeSession
}
